"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TTDSGConsentClient = void 0;
// Docs: https://consent-sandbox.vwgroup.io/swagger-consent-docs/swagger-ui/index.html?urls.primaryName=ttdsg-consent-collectors#/
class TTDSGConsentClient {
    constructor(authServiceWeConnect, localeService, stage) {
        this.authServiceWeConnect = authServiceWeConnect;
        this.localeService = localeService;
        this.stage = stage;
        this.getGdcType = (isWcar) => isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`;
        this.locale = `${this.localeService.language}-${this.localeService.countryCode}`;
        this.resourceHostId = `myvw-ttdsg-consent-${stage}`;
    }
    async getDocumentConsentVehicleV1(isWcar, userId) {
        const response = await this.authServiceWeConnect.get(this.resourceHostId, `api/v1/consents/vehicle?gdc=${this.getGdcType(isWcar)}&userId=${userId}&locale=${this.locale}`);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return await response.json();
    }
    async getDocumentConsentVehicleV2(isWcar, userId) {
        const response = await this.authServiceWeConnect.get(this.resourceHostId, `api/v2/consents/vehicle?gdc=${this.getGdcType(isWcar)}&userId=${userId}&locale=${this.locale}`);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return await response.json();
    }
    async createConsent(payload, isWcar, userId) {
        const response = await this.authServiceWeConnect.post(this.resourceHostId, `api/v1/consents/vehicle?gdc=${this.getGdcType(isWcar)}&userId=${userId}&locale=${this.locale}`, JSON.stringify(payload), {
            'Content-Type': 'application/json',
        });
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }
    async updateConsent(consentID, decision, isWcar) {
        const response = await this.authServiceWeConnect.put(this.resourceHostId, `api/v1/consents/vehicle/${consentID}?gdc=${this.getGdcType(isWcar)}`, JSON.stringify(decision), {
            'Content-Type': 'application/json',
        });
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }
}
exports.TTDSGConsentClient = TTDSGConsentClient;
//# sourceMappingURL=ttdsgConsentClient.js.map